<template>
  <div>
    <div class="checkbox">
      <label>
        <input 
          type="checkbox" 
          name="authorization_arvo" 
          id="authorization_arvo" 
          v-model="authorization_arvo" 
          @change="clickToggle"
        >
        Arvo-palvelu

        <span v-if="loading">
          <i class="fa fa-spinner fa-spin fa-fw"></i>
          <span class="sr-only">Waiting...</span>
        </span>

      </label>

      <span v-if="error">
        <i class="fa fa-times fa-2x" style="color: red"></i>
        <span class="sr-only">failed</span>
      </span>

    </div> 


  </div>
 </template>

<script>
  export default {
    
    props: {
      user: Object,
    },

    data: function () {
      return {
        authorization_arvo: '',
        loading: false,
        error: false,
      }
    },

    created: function () {
      this.authorization_arvo = this.user.authorization_arvo
    },

    methods: {
      clickToggle: function() {
        this.loading = true
        this.error = false

        axios.post(`/staff/user/${this.user.id}/toggleArvo`)
        .then((response) => {
          console.log(response)
          this.toggle(response.data.authorization_arvo)
        })
        .catch((error) => {
          this.error = true
          console.log(error)
          this.toggle(this.user.authorization_arvo)
        })
        .finally(() => {
          this.loading = false
        });
      },

      toggle: function(value) {
        this.authorization_arvo = value ? 1 : 0
      },

    }

  }
</script>
